/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/inbox/supplierInvoicesInbox/sessionStorageHelper"/>

export const sessionStorageKey = 'supplierInvoicesInbox';

export const ToggleNewInboxMessage = 'TOGGLE_NEW_INBOX';
const stateChangedEventName = 'STATE_CHANGED';

enum InboxMode {
    Mine = 'mine',
    All = 'all'
}

export type SupplierInvoicesInboxSessionStorage = {
    tab: string;
    mine: string;
    all?: string;
};

export const initialSessionStorage: SupplierInvoicesInboxSessionStorage = {
    tab: InboxMode.Mine,
    mine: `#/Tasks?tab=${InboxMode.Mine}`,
    all: `#/Tasks?tab=${InboxMode.All}`
};

export const createInboxHash = (window: Window) => {
    const inboxSessionStorage = getInboxSessionStorageOrInitialize(window.sessionStorage);
    const newHash = createHash(inboxSessionStorage);

    return newHash;
};

const createHash = (inboxSessionStorage: SupplierInvoicesInboxSessionStorage): string => {
    const hashQuery =
        inboxSessionStorage.tab === InboxMode.Mine
            ? inboxSessionStorage.mine || initialSessionStorage.mine
            : inboxSessionStorage.all || initialSessionStorage.all;
    return hashQuery;
};

const getInboxSessionStorageOrInitialize = (
    sessionStorage: Storage
): SupplierInvoicesInboxSessionStorage => {
    const sessionStorageData = sessionStorage.getItem(sessionStorageKey);
    return sessionStorageData ? JSON.parse(sessionStorageData) : initialSessionStorage;
};

export const handleStateChange = (window: Window, url: string) => {
    window.postMessage({ type: stateChangedEventName, url }, '*');
};
